import Divider from "@components/Divider/Divider";
import { ThemeEnum } from "@components/ThemeProvider/ThemeProvider";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";

type SubHeaderProps = {
  title: string;
  noIcon?: boolean;
  theme?: ThemeEnum;
  showDivider?: boolean;
  onPrev?: () => void;
  onNext?: () => void;
  disabledPrev?: boolean;
  disabledNext?: boolean;
  className?: string;
};

export default function SubHeader({
  title,
  noIcon = false,
  theme = ThemeEnum.light,
  showDivider = true,
  onPrev,
  onNext,
  disabledPrev = false,
  disabledNext = false,
  className,
}: SubHeaderProps) {
  const isDark = theme === ThemeEnum.dark;

  return (
    <div className={clsx("flex w-full flex-col", className)}>
      <div
        className={clsx(
          "flex w-full items-center justify-between px-3 py-4 pb-2",
          isDark && "bg-background-primary-on-dark",
        )}
      >
        <div className="flex items-center gap-2">
          <h3
            className={clsx(
              "text-header-3 shrink-0",
              isDark ? "text-primary-on-dark" : "text-primary",
            )}
          >
            {title}
          </h3>
          {!noIcon && (
            <div className="bg-button-primary flex size-6 shrink-0 items-center justify-center rounded-full">
              <FontAwesomeIcon
                icon={faArrowRight}
                className="size-3 text-white"
              />
            </div>
          )}
        </div>

        <div className="flex items-center gap-2">
          {onPrev && (
            <button
              onClick={onPrev}
              disabled={disabledPrev}
              className={clsx(
                "flex size-6 shrink-0 cursor-pointer items-center justify-center",
                disabledPrev
                  ? "text-tertiary cursor-not-allowed"
                  : isDark
                    ? "text-primary-on-dark"
                    : "text-primary",
              )}
              aria-label="Previous"
            >
              <FontAwesomeIcon icon={faArrowLeft} className="size-4" />
            </button>
          )}
          {onNext && (
            <button
              onClick={onNext}
              disabled={disabledNext}
              className={clsx(
                "flex size-6 shrink-0 cursor-pointer items-center justify-center",
                disabledNext
                  ? "text-tertiary cursor-not-allowed"
                  : isDark
                    ? "text-primary-on-dark"
                    : "text-primary",
              )}
              aria-label="Next"
            >
              <FontAwesomeIcon icon={faArrowRight} className="size-4" />
            </button>
          )}
        </div>
      </div>

      {showDivider && (
        <div className="px-3">
          <Divider className="my-0!" />
        </div>
      )}
    </div>
  );
}
